import AppStoreOverlay from './container/AppStoreOverlay'

export default AppStoreOverlay
